import utils from 'utils'
import invoiceModule from '../module'
import invoiceGoodsPage from '../view/invoiceGoods.html'

invoiceModule.directive(
    'invoiceGoods',
    ['$q', 'httpRequest', 'globalFn', 'dictService', '$http', 'logger',
        ($q, httpRequest, globalFn, dictService, $http, logger) => ({
            restrict: 'E',
            replace: true,
            template: invoiceGoodsPage,
            scope: {
                invoice: '<',
                selectedRows: '<',
            },
            controller: ['$scope', ($scope) => {
                $scope.commonScroll = function commonScroll() {
                    document.activeElement.blur()
                    $scope.getAmount()
                }
                $scope.onScrollDown = function () {
                    if ($scope.invoice.min + $scope.invoice.step < $scope.invoice.details.length && $scope.invoice.max < $scope.invoice.details.length) {
                        $scope.invoice.min += $scope.invoice.step
                        $scope.invoice.max += $scope.invoice.step
                        if ($scope.invoice.details.length - $scope.invoice.max < 11) {
                            $scope.invoice.max = $scope.invoice.details.length
                        }
                        const msg = `正在加载${$scope.invoice.min + 2}-${$scope.invoice.max}条商品明细,共${$scope.invoice.details.length}条`
                        utils.loading(msg)
                        $scope.getAmount()
                        $scope.$apply()
                        setTimeout(() => {
                            $('.slimScrollBar').css({
                                top: 0.5,
                            })
                            utils.loaded()
                        }, 800)
                    }
                }
                $scope.onScrollTop = function () {
                    if ($scope.invoice.min - $scope.invoice.step > -2) {
                        $scope.invoice.min -= $scope.invoice.step
                        $scope.invoice.max = $scope.invoice.min + $scope.invoice.step + 1
                        if ($scope.invoice.details.length - $scope.invoice.max < 11) {
                            $scope.invoice.max = $scope.invoice.details.length
                        }
                        const msg = `正在加载${$scope.invoice.min + 2}-${$scope.invoice.max}条商品明细,共${$scope.invoice.details.length}条`
                        utils.loading(msg)
                        $scope.getAmount()
                        $scope.$apply()
                        setTimeout(() => {
                            $('.slimScrollBar').css({
                                top: 0.5,
                            })
                            utils.loaded()
                        }, 800)
                    }
                }
                $scope.getAmount = function getAmount() {
                    let totalAmt = 0
                    let totalTaxamt = 0
                    for (let key = 0, len = $scope.invoice.details.length; key < len; key++) {
                        const item = $scope.invoice.details[key]
                        totalAmt = globalFn.Add(totalAmt, item.amount)
                        totalTaxamt = globalFn.Add(totalTaxamt, item.taxAmount)
                    }
                    $scope.invoice.totalAmt = totalAmt
                    $scope.invoice.adValoremTotal = parseFloat(globalFn.Add(totalTaxamt, totalAmt)).toFixed(2)
                    $scope.invoice.totalTaxamt = totalTaxamt
                }
                $scope.taxChange = function () {
                    $scope.getAmount()
                }
                $scope.$watch('invoice.details.length', () => {
                    $scope.getAmount()
                })
                $scope.$watch('invoice.isTax', () => {
                    $scope.getAmount()
                })
                // 大量使用get，set影响性能，合计计算使用getAmount，差额导致金额税额修改不会触发，但是会触发remark get 
                $scope.$watch('invoice.remark' ,()=>{
                    $scope.getAmount()
                })
            }],
            link(scope) {
                dictService.getAndCache(['zero_tax']).then((res) => {
                    scope.dictionary = res
                })
                scope.qryTaxClassList = function qryTaxClassList(val) {
                    return $http.post(`${host.etcloudOvat}settings/sysGoodsInfo/getGoodsInfoList`, val).then((response) => {
                        const resArr = response.data.value
                        if (resArr == null || resArr.length === 0) {
                            logger.logError('没有找到相应商品')
                            return resArr
                        }
                        return resArr.map((item) => $.extend({}, {
                            goodsCodeAndGoodsName: `${item.goodsCode}      ${item.goodsName}         ${item.taxRate * 100}`,
                        }, item))
                    })
                }

                function getGoodsInfoTax(goods, invoiceType) {
                    const rateReq = {
                        taxMergeCode: goods.taxMergeCode,
                        invType: invoiceType,
                        privilegeType: encodeURIComponent(goods.privilegeType),
                    }
                    return httpRequest.get_queryGoodsTax(rateReq).then((res) => res.data.value)
                }
                // 选中商品行
                scope.qryTaxClassInfo = function qryTaxClassInfo($item, goods) {
                    // goods = new Goods().fromGoods($item)
                    goods.fromGoods($item)
                    goods.isTax = scope.invoice.isTax
                    getGoodsInfoTax($item, scope.invoice.invType).then((reteArr) => {
                        const zeroTaxArr = scope.dictionary.zero_tax
                        for (let i = 0, l = zeroTaxArr.length; i < l; i++) {
                            if (zeroTaxArr[i].enumName === $item.privilegeType && reteArr[0].taxRate === 0) {
                                goods.zeroTax = zeroTaxArr[i].enumCode
                            }
                        }
                        goods.taxRateArr = reteArr
                        // makeTaxRateObj(goods)
                        goods.taxRateLoaded = true
                        scope.getAmount()
                    })
                }
            },
        }),
    ],
)



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/components/invoiceGoods.js